import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/layouts/Header";
import { Footer } from "@/layouts/Footer";
import { ScrollToTop } from "@/components/common/ScrollToTop";
import { PageLoader } from "@/components/common/PageLoader";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

/**
 * Global layout applied to every route: smooth scroll, scroll restoration,
 * header, footer and toast portal. Page content renders through <Outlet />.
 */
export function RootLayout() {
  useSmoothScroll();

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <ScrollToTop />
      <Header />
      <main id="main" className="flex-1">
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{ className: "font-body" }}
      />
    </div>
  );
}
